/* backendSettingsThunk.ts */

/* Redux-Toolkit */
import { createAsyncThunk } from "@reduxjs/toolkit";

/* Axios */
import { HttpStatusCode, isAxiosError } from "axios";
import axiosInterceptor from "src/utils/helper/axios-interceptor";

/* Interfaces */
import { BackendSettingsProps } from "src/shared/interfaces/admin-dashboard/Settings";

export const fetchBackendSettings = createAsyncThunk(
  "settings/fetchBackendSettings",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInterceptor.get<unknown>(
        "/options/settings"
      );
      const restrictionFlag = (
        response.data as {
          care_site_restriction_enabled?: unknown;
        }
      )?.care_site_restriction_enabled;

      if (typeof restrictionFlag !== "boolean") {
        return rejectWithValue(
          "Invalid backend settings response shape"
        );
      }

      return {
        careSiteRestrictionEnabled: restrictionFlag,
        status: "success",
      } as BackendSettingsProps;
    } catch (error) {
      if (
        isAxiosError(error) &&
        error.response?.status === HttpStatusCode.NotFound
      ) {
        // Older backend without this endpoint — treat restriction as disabled
        return {
          careSiteRestrictionEnabled: false,
          status: "success",
        } as BackendSettingsProps;
      }
      return rejectWithValue("Failed to load backend settings");
    }
  }
);
